<template>
  <section id="services" class="text-center">
    <h2>Our Services</h2>

    <div class="row mt-4">

      <div class="col-md-4">
        <div class="p-3">
          <img src="../../assets/img/services-1.webp" class="rounded-circle mb-2" alt="Custom Moulding">
          <h3>Custom Moulding</h3>
          <p>Bespoke GRP moulds crafted to your exact specifications, from concept to finished part.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="p-3">
          <img src="../../assets/img/services-2.webp" class="rounded-circle mb-2" alt="Fibreglass Repairs">
          <h3>Fibreglass Repairs</h3>
          <p>Professional repair and refinishing of damaged GRP parts to restore strength and appearance.</p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="p-3">
          <img src="../../assets/img/services-3.webp" class="rounded-circle mb-2" alt="Production Runs">
          <h3>Production Runs</h3>
          <p>Small to large-scale manufacturing of durable fibreglass components with consistent quality.</p>
        </div>
      </div>

            <div class="w-100 text-center  flex items-center justify-between banner">
        <div class="p-3">
          <p>Please call us for any shipping costs before ordering. Especially for the larger items.</p>
        </div>
      </div>

    </div>
  </section>
</template>

<style scoped>
.banner {
  background-color: #e0901f;
  color: #fff;
  z-index: 999999;
  position:absolute;
  bottom:0;
}
section {
  position: relative;
  background-image: url('../../assets/img/background-repeater.webp');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  color: black;
  width: 100%;
  padding: 100px 20px;
}

img {
  height: 150px;
  width: 150px;
}
</style>
